/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ExperienceLevel
 */
export interface ExperienceLevel {
    /**
     * 
     * @type {string}
     * @memberof ExperienceLevel
     */
    value: ExperienceLevelValueEnum;
}


/**
 * @export
 */
export const ExperienceLevelValueEnum = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type ExperienceLevelValueEnum = typeof ExperienceLevelValueEnum[keyof typeof ExperienceLevelValueEnum];


/**
 * Check if a given object implements the ExperienceLevel interface.
 */
export function instanceOfExperienceLevel(value: object): value is ExperienceLevel {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function ExperienceLevelFromJSON(json: any): ExperienceLevel {
    return ExperienceLevelFromJSONTyped(json, false);
}

export function ExperienceLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceLevel {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function ExperienceLevelToJSON(value?: ExperienceLevel | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
    };
}

